import { render, staticRenderFns } from "./details-skeleton.vue?vue&type=template&id=a50365aa"
import script from "./details-skeleton.vue?vue&type=script&lang=js"
export * from "./details-skeleton.vue?vue&type=script&lang=js"
import style0 from "./details-skeleton.vue?vue&type=style&index=0&id=a50365aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports